const set = (key, value) => {
  localStorage.setItem(key, value);
}

const get = (key, defaultValue) => {
  try {
    return localStorage.getItem(key);
  } catch(e) {
    return defaultValue;
  }
}

const clearAll = () => {
  localStorage.clear();
};

export { set, get, clearAll };